namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeItemColumns {
        static columnsKey = 'InitialData.PsDiscCouponTypeItem';
    }
}
